import { isFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18960
// Full-block экран делаем независимым от promo
export const overquotaNonPromoFlow: boolean | undefined = isFeature('overquota-nonpromo-flow');
